// src/services/api.ts
import axios from "axios";
import router from "@/router";
import { useUserStore } from "@/stores/userStore";

const envBase = (import.meta.env.VITE_API_BASE_URL || "").trim();

// 1) Base par défaut: PROXY Vite
let baseURL = "/api";

// 2) Si on t’a donné une base explicite, on l’utilise… sauf si c’est un localhost vu depuis un autre device
if (envBase) baseURL = envBase;

// 3) Filet de sécurité : si le front n’est PAS sur localhost mais la base commence par http://localhost, on repasse en proxy
if (
  typeof window !== "undefined" &&
  window.location.hostname !== "localhost" &&
  /^https?:\/\/localhost[:/]/i.test(baseURL)
) {
  baseURL = "/api";
}

console.log("API baseURL =", baseURL);

export const api = axios.create({
  baseURL,
  withCredentials: true, // si tu utilises des cookies de session
});

// Ajout token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("editortoken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Gestion 401/403
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response && [401, 403].includes(error.response.status)) {
      localStorage.removeItem("editortoken");
      try {
        const userStore = useUserStore();
        userStore?.logout?.();
      } catch {}
      const current = router.currentRoute?.value?.name;
      if (current !== "login") router.push({ name: "login" }).catch(() => {});
    }
    return Promise.reject(error);
  }
);

export default api;
